// import { X, Save, Wrench } from 'lucide-react';
// import { useEffect, useState } from 'react';
// import { useUpdateService } from '../hooks/useUpdateService';
// import {

//  useUploadServiceVideo

// }

// from

// '../hooks/useUploadServiceVideo';

// export const EditServiceModal = ({
//   isEditModalOpen,
//   setIsEditModalOpen,
//   service,
// }) => {

//  const {

//  mutate:updateService,

//  isPending

// }

// =

// useUpdateService();



// const uploadVideoMutation=

// useUploadServiceVideo();


// const uploadImageMutation = useUploadServiceVideo();

//   const [formData, setFormData] = useState({
//     description: '',

//     shortDescription: '',

//     duration: '',

//     visitCharge: '',

//     serviceCharge: '',

//     serviceLocation: '',

//     externalVideoLink: '',

//     approvalStatus: '',

//     rejectionReason: '',

//     isActive: false,

//     isPopular: false,

//     isFeatured: false,

//     videos: [],
//   });

//   const [videosText, setVideosText] = useState('');

//   const [

//  videoFiles,

//  setVideoFiles

// ]

// =

// useState([]);


// const [imageFiles, setImageFiles] = useState([]);




//   useEffect(() => {
//     if (service) {
//       setFormData({
//         description:
//           service.description || '',

//         shortDescription:
//           service.shortDescription || '',

//         duration:
//           service.duration || '',

//         visitCharge:
//           service.visitCharge || '',

//         serviceCharge:
//           service.serviceCharge || '',

//         serviceLocation:
//           service.serviceLocation || '',

//         externalVideoLink:
//           service.externalVideoLink || '',

//         approvalStatus:
//           service.approvalStatus ||
//           'pending',

//         rejectionReason:
//           service.rejectionReason || '',

//         isActive:
//           service.isActive || false,

//         isPopular:
//           service.isPopular || false,

//         isFeatured:
//           service.isFeatured || false,

//         videos:
//           service.videos || [],

//           images:
//   (service.images || []).filter(
//     (img) => img?.key
//   ),
//       });

//     }
//   }, [service]);

//   const handleChange = (e) => {
//     const {
//       name,
//       value,
//       type,
//       checked,
//     } = e.target;

//     setFormData((prev) => ({
//       ...prev,
//       [name]:
//         type === 'checkbox'
//           ? checked
//           : value,
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const payload = {
//       description:
//         formData.description,

//       shortDescription:
//         formData.shortDescription,

//       duration:
//         Number(formData.duration),

//       visitCharge:
//         Number(formData.visitCharge),

//       serviceCharge:
//         Number(formData.serviceCharge),

//       serviceLocation:
//         formData.serviceLocation,

//       externalVideoLink:
//         formData.externalVideoLink,

//       approvalStatus:
//         formData.approvalStatus,

//       isActive:
//         formData.isActive,

//       isPopular:
//         formData.isPopular,

//       isFeatured:
//         formData.isFeatured,

//       videos:
//         formData.videos,

//         images:
//   formData.images,
//     };

//     if (
//       formData.approvalStatus ===
//         'rejected' &&
//       formData.rejectionReason
//     ) {
//       payload.rejectionReason =
//         formData.rejectionReason;
//     }

//     updateService(
//       {
//         serviceId: service._id,
//         data: payload,
//       },
//       {
//         onSuccess: () => {
//           setIsEditModalOpen(false);
//         },
//       }
//     );
//   };

//   if (!isEditModalOpen || !service)
//     return null;

//   const isApprovalLocked =
//     service.approvalStatus !==
//     'pending';

//   return (
//     <div className='fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4'>

//       <div className='bg-card border border-border rounded-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto custom-scrollbar'>

//         {/* HEADER */}

//         <div className='sticky top-0 bg-card border-b border-border px-6 py-4 flex items-center justify-between'>

//           <div className='flex items-center space-x-3'>

//             <div className='p-2 bg-primary/10 rounded-lg'>
//               <Wrench
//                 size={20}
//                 className='text-primary'
//               />
//             </div>

//             <div>
//               <h2 className='text-lg font-semibold'>
//                 Edit Service
//               </h2>

//               <p className='text-xs text-muted-foreground'>
//                 {service.name}
//               </p>
//             </div>
//           </div>

//           <button
//             onClick={() =>
//               setIsEditModalOpen(false)
//             }
//             className='p-1 hover:bg-muted rounded-md transition-colors'
//           >
//             <X size={20} />
//           </button>
//         </div>

//         {/* FORM */}

//         <form
//           onSubmit={handleSubmit}
//           className='p-6 space-y-6'
//         >

//           {/* READ ONLY INFO */}

//           <div className='bg-muted rounded-lg p-4'>

//             <h3 className='text-sm font-medium mb-3'>
//               Service Information
//             </h3>

//             <div className='grid grid-cols-2 gap-3 text-sm'>

//               <div>
//                 <span className='text-muted-foreground'>
//                   Name:
//                 </span>

//                 <span className='ml-2 font-medium'>
//                   {service.name}
//                 </span>
//               </div>

//               <div>
//                 <span className='text-muted-foreground'>
//                   Price:
//                 </span>

//                 <span className='ml-2 font-medium'>
//                   {service.pricing?.currency ||
//                     'INR'}{' '}

//                   {service.pricing
//                     ?.basePrice || 0}
//                 </span>
//               </div>

//               <div>
//                 <span className='text-muted-foreground'>
//                   Seller:
//                 </span>

//                 <span className='ml-2 font-medium'>
//                   {service.sellerId
//                     ?.firstName || ''}{' '}

//                   {service.sellerId
//                     ?.lastName || ''}
//                 </span>
//               </div>

//               <div>
//                 <span className='text-muted-foreground'>
//                   Pricing Type:
//                 </span>

//                 <span className='ml-2 font-medium capitalize'>
//                   {service.pricing
//                     ?.type || 'fixed'}
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* DESCRIPTION */}

//           <div className='space-y-2'>

//             <label className='text-sm font-medium'>
//               Description
//             </label>

//             <textarea
//               name='description'
//               value={
//                 formData.description
//               }
//               onChange={handleChange}
//               rows={4}
//               className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background'
//             />
//           </div>

//           {/* SHORT DESCRIPTION */}

//           <div className='space-y-2'>

//             <label className='text-sm font-medium'>
//               Short Description
//             </label>

//             <textarea
//               name='shortDescription'
//               value={
//                 formData.shortDescription
//               }
//               onChange={handleChange}
//               rows={2}
//               className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background'
//             />
//           </div>

//           <div className='space-y-4'>

//   <label className='text-sm font-medium'>
//     Images
//   </label>

//   <input
//     type='file'
//     accept='image/*'
//     multiple
//     onChange={(e) => {
//       setImageFiles(
//         Array.from(e.target.files)
//       );
//     }}
//   />

//   {formData.images?.length > 0 && (
//     <div className='grid grid-cols-2 md:grid-cols-3 gap-4'>

//       {formData.images.map((image, i) => (

//         <div
//           key={i}
//           className='border rounded-lg p-2'
//         >

//           <img
//             src={
//               typeof image === 'string'
//                 ? image
//                 : image?.presignedUrl
//             }
//             alt='service'
//             className='w-full h-32 object-cover rounded'
//           />

//           <button
//             type='button'
//             onClick={() => {

//               setFormData(prev => ({
//                 ...prev,

//                 images:
//                   prev.images.filter(
//                     (_, index) =>
//                       index !== i
//                   )
//               }));

//             }}
//             className='w-full mt-2 px-3 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600'
//           >
//             Remove Image
//           </button>

//         </div>

//       ))}

//     </div>
//   )}

//   <button
//     type='button'
//     disabled={
//       uploadImageMutation.isPending ||
//       !imageFiles.length
//     }
//     onClick={async () => {

//       let uploaded = [
//         ...formData.images
//       ];

//       for (const file of imageFiles) {

//         const res =
//           await uploadImageMutation.mutateAsync(
//             file
//           );

//         uploaded.push({
//           url: res?.data?.key,
//           isPrimary: false,
//           caption: null,
//         });

//       }

//       setFormData(prev => ({
//         ...prev,
//         images: uploaded
//       }));

//       setImageFiles([]);

//     }}
//     className='px-4 py-2 bg-primary text-white rounded-lg'
//   >
//     {
//       uploadImageMutation.isPending
//         ? 'Uploading...'
//         : 'Upload Images'
//     }
//   </button>

// </div>

//           {/* VIDEOS */}

// <div className='space-y-2'>

//   <label className='text-sm font-medium'>
//     Videos
//   </label>

//  <div className='space-y-4'>

// <label
// className='text-sm font-medium'
// >

// Videos

// </label>



// <input

//  type='file'

//  accept='video/*'

//  multiple


//  onChange={(e)=>{

//     setVideoFiles(

//        Array.from(

//           e.target.files

//        )

//     );

//  }}

// />



// {
//  formData.videos.length > 0 && (

//   <div className='space-y-4'>

//     {

//      formData.videos.map(

//       (
//        video,
//        i
//       )=>(


// <div

//  key={i}

//  className='

//  border

//  rounded-lg

//  p-3

//  space-y-3

//  '

// >


// <video

//  src={video}

//  controls

//  className='

//  w-full

//  rounded-lg

//  '

// />



// <button

//  type='button'


//  onClick={()=>{

//    setFormData(

//      prev=>({

//         ...prev,


//         videos:

//         prev.videos.filter(

//            (

//             _,

//             index

//            )=>

//            index !== i

//         )


//      })

//    );

//  }}



//  className='

//  px-3

//  py-1

//  text-sm

//  bg-red-500

//  text-white

//  rounded

//  hover:bg-red-600

//  '

// >

// Remove Video

// </button>


// </div>


// )

// )

// }

// </div>

// )
// }



// <button

//  type='button'


//  disabled={

//  uploadVideoMutation

//  .isPending ||

//  !videoFiles.length

//  }



//  onClick={

//  async()=>{


//  let uploaded=[

//   ...formData.videos

//  ];



//  for(

//  const file

//  of videoFiles

//  ){


//  const res=

//  await

//  uploadVideoMutation

//  .mutateAsync(

//    file

//  );



//  uploaded.push(

//    res?.data?.key

//  );



//  }



//  setFormData(

//    prev=>({

//       ...prev,

//       videos:

//       uploaded

//    })

//  );



//  setVideoFiles(

//  []

//  );



//  }

//  }


//  className='

//  px-4

//  py-2

//  bg-primary

//  text-white

//  rounded-lg

//  '

// >


// {

//  uploadVideoMutation

//  .isPending

//  ?

//  'Uploading...'

//  :

//  'Upload Videos'

// }


// </button>

// </div>

//   {/* <p className='text-xs text-muted-foreground'>
//     Add one video URL per line
//   </p> */}

// </div>

//           {/* DURATION */}

//           {/* <div className='space-y-2'>

//             <label className='text-sm font-medium'>
//               Duration (Minutes)
//             </label>

//             <input
//               type='number'
//               name='duration'
//               value={formData.duration}
//               onChange={handleChange}
//               className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background'
//             />
//           </div> */}

//           {/* VISIT CHARGE */}

//           {/* <div className='space-y-2'>

//             <label className='text-sm font-medium'>
//               Visit Charge
//             </label>

//             <input
//               type='number'
//               name='visitCharge'
//               value={
//                 formData.visitCharge
//               }
//               onChange={handleChange}
//               className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background'
//             />
//           </div> */}

//           {/* SERVICE CHARGE */}

//           {/* <div className='space-y-2'>

//             <label className='text-sm font-medium'>
//               Service Charge
//             </label>

//             <input
//               type='number'
//               name='serviceCharge'
//               value={
//                 formData.serviceCharge
//               }
//               onChange={handleChange}
//               className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background'
//             />
//           </div> */}

//           {/* LOCATION */}

//           <div className='space-y-2'>

//             <label className='text-sm font-medium'>
//               Service Location
//             </label>

//             <input
//               type='text'
//               name='serviceLocation'
//               value={
//                 formData.serviceLocation
//               }
//               onChange={handleChange}
//               className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background'
//             />
//           </div>

//           {/* APPROVAL STATUS */}

//           <div className='space-y-2'>

//             <label className='text-sm font-medium'>
//               Approval Status
//             </label>

//             {isApprovalLocked ? (
//               <div className='px-3 py-2 border border-border rounded-md bg-muted text-sm capitalize'>
//                 {
//                   formData.approvalStatus
//                 }
//               </div>
//             ) : (
//               <select
//                 name='approvalStatus'
//                 value={
//                   formData.approvalStatus
//                 }
//                 onChange={handleChange}
//                 className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background'
//               >
//                 <option value='pending'>
//                   Pending
//                 </option>

//                 <option value='approved'>
//                   Approved
//                 </option>

//                 <option value='rejected'>
//                   Rejected
//                 </option>
//               </select>
//             )}
//           </div>

//           {/* REJECTION REASON */}

//           {formData.approvalStatus ===
//             'rejected' && (
//             <div className='space-y-2'>

//               <label className='text-sm font-medium'>
//                 Rejection Reason
//               </label>

//               {isApprovalLocked ? (
//                 <div className='w-full px-3 py-2 text-sm border border-border rounded-md bg-muted'>
//                   <p className='whitespace-pre-wrap'>
//                     {service.rejectionReason ||
//                       'No reason provided'}
//                   </p>
//                 </div>
//               ) : (
//                 <textarea
//                   name='rejectionReason'
//                   value={
//                     formData.rejectionReason
//                   }
//                   onChange={handleChange}
//                   rows={4}
//                   className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background'
//                   placeholder='Provide rejection reason...'
//                 />
//               )}
//             </div>
//           )}

//           {/* TOGGLES */}

//           {/* <div className='space-y-4'>

//             <label className='text-sm font-medium'>
//               Status & Flags
//             </label>


//             <div className='flex items-center justify-between p-3 bg-muted rounded-lg'>

//               <div>
//                 <p className='text-sm font-medium'>
//                   Active Status
//                 </p>

//                 <p className='text-xs text-muted-foreground'>
//                   Make service visible
//                 </p>
//               </div>

//               <input
//                 type='checkbox'
//                 name='isActive'
//                 checked={
//                   formData.isActive
//                 }
//                 onChange={handleChange}
//               />
//             </div>


//             <div className='flex items-center justify-between p-3 bg-muted rounded-lg'>

//               <div>
//                 <p className='text-sm font-medium'>
//                   Popular
//                 </p>

//                 <p className='text-xs text-muted-foreground'>
//                   Mark as popular
//                 </p>
//               </div>

//               <input
//                 type='checkbox'
//                 name='isPopular'
//                 checked={
//                   formData.isPopular
//                 }
//                 onChange={handleChange}
//               />
//             </div>


//             <div className='flex items-center justify-between p-3 bg-muted rounded-lg'>

//               <div>
//                 <p className='text-sm font-medium'>
//                   Featured
//                 </p>

//                 <p className='text-xs text-muted-foreground'>
//                   Feature this service
//                 </p>
//               </div>

//               <input
//                 type='checkbox'
//                 name='isFeatured'
//                 checked={
//                   formData.isFeatured
//                 }
//                 onChange={handleChange}
//               />
//             </div>
//           </div> */}

//           {/* FOOTER */}

//           <div className='flex justify-end space-x-3 pt-4 border-t border-border'>

//             <button
//               type='button'
//               onClick={() =>
//                 setIsEditModalOpen(false)
//               }
//               className='px-4 py-2 text-sm border border-border rounded-md hover:bg-accent transition-colors'
//               disabled={isPending}
//             >
//               Cancel
//             </button>

//             <button
//               type='submit'
//               disabled={isPending}
//               className='flex items-center space-x-2 px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
//             >
//               <Save size={16} />

//               <span>
//                 {isPending
//                   ? 'Saving...'
//                   : 'Save Changes'}
//               </span>
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };


import { X, Save, Wrench } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useUpdateService } from '../hooks/useUpdateService';
import { useUploadServiceVideo } from '../hooks/useUploadServiceVideo';

export const EditServiceModal = ({
  isEditModalOpen,
  setIsEditModalOpen,
  service,
}) => {
  const { mutate: updateService, isPending } = useUpdateService();

  const uploadVideoMutation = useUploadServiceVideo();
  const uploadImageMutation = useUploadServiceVideo();

  const [formData, setFormData] = useState({
    description: '',
    shortDescription: '',
    duration: '',
    visitCharge: '',
    serviceCharge: '',
    serviceLocation: '',
    externalVideoLink: '',
    approvalStatus: '',
    rejectionReason: '',
    isActive: false,
    isPopular: false,
    isFeatured: false,
    // Each video: { key: string, preSignedUrl: string }
    videos: [],
    // Each image: { key: string, preSignedUrl: string, isPrimary: bool, caption: null }
    images: [],
  });

  const [videoFiles, setVideoFiles] = useState([]);
  const [imageFiles, setImageFiles] = useState([]);

  useEffect(() => {
    if (service) {
      setFormData({
        description: service.description || '',
        shortDescription: service.shortDescription || '',
        duration: service.duration || '',
        visitCharge: service.visitCharge || '',
        serviceCharge: service.serviceCharge || '',
        serviceLocation: service.serviceLocation || '',
        externalVideoLink: service.externalVideoLink || '',
        approvalStatus: service.approvalStatus || 'pending',
        rejectionReason: service.rejectionReason || '',
        isActive: service.isActive || false,
        isPopular: service.isPopular || false,
        isFeatured: service.isFeatured || false,
        // Normalize existing videos — keep objects with key + preSignedUrl
        videos: (service.videos || [])
          .filter((v) => v != null)
          .map((v) =>
            typeof v === 'string'
              ? { key: v, preSignedUrl: v }
              : { key: v.key, preSignedUrl: v.preSignedUrl || v.presignedUrl || v.key }
          ),
        // Normalize existing images — support both `url` (DB shape) and `key` (freshly uploaded shape)
        images: (service.images || [])
          .filter((img) => img != null && (img?.url || img?.key))
          .map((img) => {
            const key = img.key || img.url;
            const preSignedUrl = img.preSignedUrl || img.presignedUrl || null;
            return {
              key,
              preSignedUrl: preSignedUrl || key,
              isPrimary: img.isPrimary || false,
              caption: img.caption || null,
            };
          }),
      });
    }
  }, [service]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      description: formData.description,
      shortDescription: formData.shortDescription,
      duration: Number(formData.duration),
      visitCharge: Number(formData.visitCharge),
      serviceCharge: Number(formData.serviceCharge),
      serviceLocation: formData.serviceLocation,
      externalVideoLink: formData.externalVideoLink,
      approvalStatus: formData.approvalStatus,
      isActive: formData.isActive,
      isPopular: formData.isPopular,
      isFeatured: formData.isFeatured,
      // Send only keys to DB
      videos: formData.videos.map((v) => v.key),
      images: formData.images.map((img) => ({
        url: img.key,        // schema expects `url`, we store the S3 key here
        isPrimary: img.isPrimary,
        caption: img.caption,
      })),
    };

    if (
      formData.approvalStatus === 'rejected' &&
      formData.rejectionReason
    ) {
      payload.rejectionReason = formData.rejectionReason;
    }

    updateService(
      { serviceId: service._id, data: payload },
      {
        onSuccess: () => {
          setIsEditModalOpen(false);
        },
      }
    );
  };

  if (!isEditModalOpen || !service) return null;

  const isApprovalLocked = service.approvalStatus !== 'pending';

  return (
    <div className='fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4'>
      <div className='bg-card border border-border rounded-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto custom-scrollbar'>

        {/* HEADER */}
        <div className='sticky top-0 bg-card border-b border-border px-6 py-4 flex items-center justify-between'>
          <div className='flex items-center space-x-3'>
            <div className='p-2 bg-primary/10 rounded-lg'>
              <Wrench size={20} className='text-primary' />
            </div>
            <div>
              <h2 className='text-lg font-semibold'>Edit Service</h2>
              <p className='text-xs text-muted-foreground'>{service.name}</p>
            </div>
          </div>
          <button
            onClick={() => setIsEditModalOpen(false)}
            className='p-1 hover:bg-muted rounded-md transition-colors'
          >
            <X size={20} />
          </button>
        </div>

        {/* FORM */}
        <form onSubmit={handleSubmit} className='p-6 space-y-6'>

          {/* READ ONLY INFO */}
          <div className='bg-muted rounded-lg p-4'>
            <h3 className='text-sm font-medium mb-3'>Service Information</h3>
            <div className='grid grid-cols-2 gap-3 text-sm'>
              <div>
                <span className='text-muted-foreground'>Name:</span>
                <span className='ml-2 font-medium'>{service.name}</span>
              </div>
              <div>
                <span className='text-muted-foreground'>Price:</span>
                <span className='ml-2 font-medium'>
                  {service.pricing?.currency || 'INR'} {service.pricing?.basePrice || 0}
                </span>
              </div>
              <div>
                <span className='text-muted-foreground'>Seller:</span>
                <span className='ml-2 font-medium'>
                  {service.sellerId?.firstName || ''} {service.sellerId?.lastName || ''}
                </span>
              </div>
              <div>
                <span className='text-muted-foreground'>Pricing Type:</span>
                <span className='ml-2 font-medium capitalize'>
                  {service.pricing?.type || 'fixed'}
                </span>
              </div>
            </div>
          </div>

          {/* DESCRIPTION */}
          <div className='space-y-2'>
            <label className='text-sm font-medium'>Description</label>
            <textarea
              name='description'
              value={formData.description}
              onChange={handleChange}
              rows={4}
              className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background'
            />
          </div>

          {/* SHORT DESCRIPTION */}
          <div className='space-y-2'>
            <label className='text-sm font-medium'>Short Description</label>
            <textarea
              name='shortDescription'
              value={formData.shortDescription}
              onChange={handleChange}
              rows={2}
              className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background'
            />
          </div>

          {/* IMAGES */}
          <div className='space-y-4'>
            <label className='text-sm font-medium'>Images</label>

            <input
              type='file'
              accept='image/*'
              multiple
              onChange={(e) => setImageFiles(Array.from(e.target.files))}
            />

            {formData.images?.length > 0 && (
              <div className='grid grid-cols-2 md:grid-cols-3 gap-4'>
                {formData.images.map((image, i) => (
                  <div key={i} className='border rounded-lg p-2'>
                    <img
                      // Use preSignedUrl for preview display
                      src={image.preSignedUrl}
                      alt='service'
                      className='w-full h-32 object-cover rounded'
                    />
                    <button
                      type='button'
                      onClick={() => {
                        setFormData((prev) => ({
                          ...prev,
                          images: prev.images.filter((_, index) => index !== i),
                        }));
                      }}
                      className='w-full mt-2 px-3 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600'
                    >
                      Remove Image
                    </button>
                  </div>
                ))}
              </div>
            )}

            <button
              type='button'
              disabled={uploadImageMutation.isPending || !imageFiles.length}
              onClick={async () => {
                const uploaded = [...formData.images];

                for (const file of imageFiles) {
                  const res = await uploadImageMutation.mutateAsync(file);
                  // Store key (for DB) + preSignedUrl (for preview)
                  uploaded.push({
                    key: res?.data?.key,
                    preSignedUrl: res?.data?.preSignedUrl,
                    isPrimary: false,
                    caption: null,
                  });
                }

                setFormData((prev) => ({ ...prev, images: uploaded }));
                setImageFiles([]);
              }}
              className='px-4 py-2 bg-primary text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed'
            >
              {uploadImageMutation.isPending ? 'Uploading...' : 'Upload Images'}
            </button>
          </div>

          {/* VIDEOS */}
          <div className='space-y-4'>
            <label className='text-sm font-medium'>Videos</label>

            <input
              type='file'
              accept='video/*'
              multiple
              onChange={(e) => setVideoFiles(Array.from(e.target.files))}
            />

            {formData.videos.length > 0 && (
              <div className='grid grid-cols-2 md:grid-cols-3 gap-4'>
                {formData.videos.map((video, i) => (
                  <div key={i} className='border rounded-lg p-2'>
                    <video
                      // Use preSignedUrl for preview
                      src={video.preSignedUrl}
                      controls
                      className='w-full h-32 object-cover rounded'
                    />
                    <button
                      type='button'
                      onClick={() => {
                        setFormData((prev) => ({
                          ...prev,
                          videos: prev.videos.filter((_, index) => index !== i),
                        }));
                      }}
                      className='px-3 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600'
                    >
                      Remove Video
                    </button>
                  </div>
                ))}
              </div>
            )}

            <button
              type='button'
              disabled={uploadVideoMutation.isPending || !videoFiles.length}
              onClick={async () => {
                const uploaded = [...formData.videos];

                for (const file of videoFiles) {
                  const res = await uploadVideoMutation.mutateAsync(file);
                  // Store key (for DB) + preSignedUrl (for preview)
                  uploaded.push({
                    key: res?.data?.key,
                    preSignedUrl: res?.data?.preSignedUrl,
                  });
                }

                setFormData((prev) => ({ ...prev, videos: uploaded }));
                setVideoFiles([]);
              }}
              className='px-4 py-2 bg-primary text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed'
            >
              {uploadVideoMutation.isPending ? 'Uploading...' : 'Upload Videos'}
            </button>
          </div>

          {/* LOCATION */}
          <div className='space-y-2'>
            <label className='text-sm font-medium'>Service Location</label>
            <input
              type='text'
              name='serviceLocation'
              value={formData.serviceLocation}
              onChange={handleChange}
              className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background'
            />
          </div>

          {/* APPROVAL STATUS */}
          <div className='space-y-2'>
            <label className='text-sm font-medium'>Approval Status</label>
            {isApprovalLocked ? (
              <div className='px-3 py-2 border border-border rounded-md bg-muted text-sm capitalize'>
                {formData.approvalStatus}
              </div>
            ) : (
              <select
                name='approvalStatus'
                value={formData.approvalStatus}
                onChange={handleChange}
                className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background'
              >
                <option value='pending'>Pending</option>
                <option value='approved'>Approved</option>
                <option value='rejected'>Rejected</option>
              </select>
            )}
          </div>

          {/* REJECTION REASON */}
          {formData.approvalStatus === 'rejected' && (
            <div className='space-y-2'>
              <label className='text-sm font-medium'>Rejection Reason</label>
              {isApprovalLocked ? (
                <div className='w-full px-3 py-2 text-sm border border-border rounded-md bg-muted'>
                  <p className='whitespace-pre-wrap'>
                    {service.rejectionReason || 'No reason provided'}
                  </p>
                </div>
              ) : (
                <textarea
                  name='rejectionReason'
                  value={formData.rejectionReason}
                  onChange={handleChange}
                  rows={4}
                  className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background'
                  placeholder='Provide rejection reason...'
                />
              )}
            </div>
          )}

          {/* FOOTER */}
          <div className='flex justify-end space-x-3 pt-4 border-t border-border'>
            <button
              type='button'
              onClick={() => setIsEditModalOpen(false)}
              className='px-4 py-2 text-sm border border-border rounded-md hover:bg-accent transition-colors'
              disabled={isPending}
            >
              Cancel
            </button>
            <button
              type='submit'
              disabled={isPending}
              className='flex items-center space-x-2 px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
            >
              <Save size={16} />
              <span>{isPending ? 'Saving...' : 'Save Changes'}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};